
import * as React from 'react';
import { Icon } from '../../icons/Icons';
import { IconContentDefinition, StyleVariant } from '../AmorgMenuTypes';
import { colorHelper } from '../helpers/colorHelper';
import styled from 'styled-components';


type IconContentProps = IconContentDefinition &
{
    isHovering:boolean,
    styleVariant:StyleVariant
}
export function IconContent(props:IconContentProps):JSX.Element
{
    return (
        <IconWrapper>
            <Icon name={props.iconName} 
                color={colorHelper.getForegroundColor(props.styleVariant)}
            />
        </IconWrapper>
    );
}

const IconWrapper = styled.div`
    flex-grow: 0;
    width: 30px;
    & svg {
        width: 90%;
        height: 90%;   
    }
`